<div class="modal-header">
    <h4 class="modal-title">Adicionar Percentual</h4>
    <button _ngcontent-jop-c162="" type="button" aria-label="Close" class="btn-close float-end" (click)="fechar()"></button>
  </div>
  <div class="modal-body">
    <input class="form-control" type="number" [(ngModel)]="percentual" placeholder="Digite o percentual" required #percentualInput>
    <div *ngIf="mensagemAviso" class="alert alert-warning">
        {{mensagemAviso}}
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="cancelar()">Cancelar</button>
    <button class="btn btn-primary" (click)="salvar()">Salvar</button>
</div>